import { render, staticRenderFns } from "./GoodsListForm.vue?vue&type=template&id=647159d0&scoped=true"
import script from "./GoodsListForm.vue?vue&type=script&lang=js"
export * from "./GoodsListForm.vue?vue&type=script&lang=js"
import style0 from "./GoodsListForm.vue?vue&type=style&index=0&id=647159d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647159d0",
  null
  
)

export default component.exports